import React, { useCallback, useEffect, useMemo, useState } from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import { Link } from 'react-router-dom';
import { Dropdown } from 'Common/Components/Dropdown';
import TableContainer from 'Common/TableContainer';
import moment from "moment";
import Select from 'react-select';

// Icons
import { Search, Trash2, Plus, MoreHorizontal, FileEdit, CheckCircle, Loader, X } from 'lucide-react';
import Modal from 'Common/Components/Modal';
import DeleteModal from 'Common/DeleteModal';

// Images

// react-redux
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import {
  getUserList as onGetUserList,
  addUserList as onAddUserList,
  updateUserList as onUpdateUserList,
  deleteUserList as onDeleteUserList,
  activeUserList as onActiveUserList,
} from 'slices/thunk';
import { ToastContainer } from 'react-toastify';
import filterDataBySearch from 'Common/filterDataBySearch';
import ActiveModal from '../../Common/ActiveModal';
import { doGetRoleAccess } from '../../services/auth.service';
import DropZoneImage from '../../Common/Components/Dropzone';
import { doFileUpload } from '../../services/file.service';
import { OperatingHours } from '../../Common/Components/OperatingHours';

const ListView = () => {
  const dispatch = useDispatch<any>();

  const selectDataList = createSelector(
    (state: any) => state.Users,
    (user) => ({
      userList: user.userList
    })
  );

  const { userList } = useSelector(selectDataList);
  const [user, setUser] = useState<any>([]);
  const [eventData, setEventData] = useState<any>();

  const [show, setShow] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const [roleSelect, setRoleSelect] = useState<[{ label: string, value: string }]>();
  const [selectfiles, setSelectfiles] = useState<Array<File & { base64: string }>>([]);

  // Get Data
  useEffect(() => {
    dispatch(onGetUserList())
  }, [dispatch]);

  useEffect(() => {
    setUser(userList)
  }, [userList]);

  useEffect(() => {
    handleGetRoleList()
  }, []);

  const handleGetRoleList = () => {
    doGetRoleAccess().then((res: any) => {
      const roleList = res.data.map((roleAccess: any) => {
        return {
          value: roleAccess.role,
          label: roleAccess.role,
        };
      });
      setRoleSelect(roleList);
    })
  }

  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);

  const [activeModal, setActiveModal] = useState<boolean>(false);
  const activeToggle = () => setActiveModal(!activeModal);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.userId) {
      setEventData(cell);
    }
  };

  const onClickActive = (cell: any) => {
    setActiveModal(true);
    if (cell.userId) {
      setEventData(cell);
    }
  };

  const handleActive = () => {
    if (eventData) {
      dispatch(onActiveUserList(eventData.userId));
      setActiveModal(false);
    }
  };

  const handleDelete = () => {
    if (eventData) {
      dispatch(onDeleteUserList(eventData.userId));
      setDeleteModal(false);
    }
  };

  // Update Data
  const handleUpdateDataClick = (ele: any) => {
    setEventData({ ...ele });
    setIsEdit(true);
    setShow(true);
  };

  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      // img: (eventData && eventData.img) || '',
      userId: (eventData && eventData.userId) || '',
      username: (eventData && eventData.username) || '',
      name: (eventData && eventData.name) || '',
      role: (eventData && eventData.role) || '',
      country: (eventData && eventData.country) || '',
      email: (eventData && eventData.email) || '',
      phoneNo: (eventData && eventData.phoneNo) || '',
      address: (eventData && eventData.address) || '',
      title: (eventData && eventData.title) || '',
      description: (eventData && eventData.description) || '',
      service: (eventData && eventData.service) || '',
      occupation: (eventData && eventData.occupation) || '',
      isProfileDisplay: (eventData && eventData.isProfileDisplay) || false,
      profilePicture: (eventData && eventData.profilePicture) || '',
      profilePictureFile: (eventData && eventData.profilePictureFile) || {},
      performService: (eventData && eventData.performService) || false,
      operation: (eventData && eventData.operation) || {},
    },
    validationSchema: Yup.object({
      // img: Yup.string().optional().nullable(),
      username: Yup.string().optional().nullable(),
      name: Yup.string().required("Please Enter Name"),
      role: Yup.string().required("Please Enter Role"),
      country: Yup.string().required("Please Enter Country"),
      email: Yup.string().optional().nullable(),
      phoneNo: Yup.string().required("Please Enter Phone Number"),
      address: Yup.string().optional().nullable(),
      title: Yup.string().optional().nullable(),
      description: Yup.string().optional().nullable(),
      service: Yup.string().optional().nullable(),
      occupation: Yup.string().optional().nullable(),
      isProfileDisplay: Yup.boolean().optional().nullable(),
      performService: Yup.boolean().optional().nullable(),
      operation: Yup.object().optional().nullable(),
    }),
    onSubmit: async (values) => {
      const image = []
      if (selectfiles.length > 0) {
        for (const file of selectfiles) {
          const fileObject = await doFileUpload(file.name, file.base64, `user:${values.userId}`)
          image.push(fileObject.fileId)
        }
        values.profilePicture = image[0]
      }

      setSelectfiles([])
      if (isEdit) {
        const updateUser = {
          ...values,
        };
        // update user
        dispatch(onUpdateUserList(updateUser));
      } else {
        delete values.userId;
        const newUser = {
          ...values,
        };
        // save new user
        dispatch(onAddUserList(newUser));
      }
      toggle();
    },
  });

  const countrySelect = [
    { value: 'ID', label: 'Indonesia' },
  ];

  //
  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setIsEdit(false);
      // setSelectedImage('');
    } else {
      setShow(true);
      setEventData("");
      // setSelectedImage('');
      validation.resetForm();
    }
  }, [show, validation]);

  // Search Data
  const filterSearchData = (e: any) => {
    const search = e.target.value;
    const keysToSearch = ['name', 'role', 'country', 'email', 'status'];
    filterDataBySearch(userList, search, keysToSearch, setUser);
  };

  // columns
  const Status = ({ item }: any) => {
    switch (item) {
      case "active":
        return (<span className="px-2.5 py-0.5 text-xs font-medium rounded border bg-green-100 border-transparent text-green-500 dark:bg-green-500/20 dark:border-transparent inline-flex items-center status"><CheckCircle className="w-3 h-3 mr-1.5" />{item}</span>);
      case "waiting":
        return (<span className="px-2.5 py-0.5 inline-flex items-center text-xs font-medium rounded border bg-slate-100 border-transparent text-slate-500 dark:bg-slate-500/20 dark:text-zink-200 dark:border-transparent status"><Loader className="w-3 h-3 mr-1.5" />{item}</span>);
      case "inactive":
        return (<span className="px-2.5 py-0.5 inline-flex items-center text-xs font-medium rounded border bg-red-100 border-transparent text-red-500 dark:bg-red-500/20 dark:border-transparent status"><X className="w-3 h-3 mr-1.5" />{item}</span>);
      default:
        return (<span className="px-2.5 py-0.5 text-xs font-medium rounded border bg-green-100 border-transparent text-green-500 dark:bg-green-500/20 dark:border-transparent inline-flex items-center status"><CheckCircle className="w-3 h-3 mr-1.5" />{item}</span>);
    }
  };

  const columns = useMemo(() => [
    {
      header: (
        <div className="flex items-center h-full">
          <input id="CheckboxAll" className="w-4 h-4 bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800 cursor-pointer" type="checkbox" />
        </div>
      ),
      enableSorting: false,
      id: "checkAll",
      cell: (cell: any) => {
        return (
          <div className="flex items-center h-full">
            <input id="Checkbox1" className="w-4 h-4 bg-white border border-slate-200 checked:bg-none dark:bg-zink-700 dark:border-zink-500 rounded-sm appearance-none arrow-none relative after:absolute after:content-['\eb7b'] after:top-0 after:left-0 after:font-remix after:leading-none after:opacity-0 checked:after:opacity-100 after:text-custom-500 checked:border-custom-500 dark:after:text-custom-500 dark:checked:border-custom-800 cursor-pointer" type="checkbox" />
          </div>
        );
      }
    },
    {
      header: "Name",
      accessorKey: "name",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <div className="flex items-center gap-2">
          <div className="flex items-center justify-center w-10 h-10 font-medium rounded-full shrink-0 bg-slate-200 text-slate-800 dark:text-zink-50 dark:bg-zink-600">
            <img src={cell.row.original.profilePictureFile?.s3Url} alt="" className="h-10 rounded-full" />
          </div>
          <div className="grow">
            <h6 className="mb-1"><Link to={"/user/" + cell.row.original.userId} className="name">{cell.getValue()}</Link></h6>
            <p className="text-slate-500 dark:text-zink-200">{cell.row.original.role}</p>
          </div>
        </div>
      ),
    },
    {
      header: "Country",
      accessorKey: "country",
      enableColumnFilter: false
    },
    {
      header: "Email",
      accessorKey: "email",
      enableColumnFilter: false,
    },
    {
      header: "Phone Number",
      accessorKey: "phoneNo",
      enableColumnFilter: false,
    },
    {
      header: "Joining Date",
      accessorKey: "createdAt",
      enableColumnFilter: false,
      cell: (cell: any) => (
        <span>{moment(cell.getValue()).format("DD MMM YYYY")}</span>
      ),
    },
    {
      header: "Status",
      accessorKey: "status",
      enableColumnFilter: false,
      enableSorting: true,
      cell: (cell: any) => (
        <Status item={cell.getValue()} />
      ),
    },
    {
      header: "Action",
      enableColumnFilter: false,
      enableSorting: true,
      cell: (cell: any) => (
        <Dropdown className="relative">
          <Dropdown.Trigger className="flex items-center justify-center w-[30px] h-[30px] p-0 text-slate-500 btn bg-slate-100 hover:text-white hover:bg-slate-600 focus:text-white focus:bg-slate-600 focus:ring focus:ring-slate-100 active:text-white active:bg-slate-600 active:ring active:ring-slate-100 dark:bg-slate-500/20 dark:text-slate-400 dark:hover:bg-slate-500 dark:hover:text-white dark:focus:bg-slate-500 dark:focus:text-white dark:active:bg-slate-500 dark:active:text-white dark:ring-slate-400/20" id={cell.row.original.userId}>
            <MoreHorizontal className="w-3 h-3" />
          </Dropdown.Trigger>
          <Dropdown.Content placement="right-end" className="absolute z-50 py-2 mt-1 ltr:text-left rtl:text-right list-none bg-white rounded-md shadow-md min-w-[10rem] dark:bg-zink-600" aria-labelledby={cell.row.original.userId}>
            {/* <li>
              <Link className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200" to="/pages-account"><Eye className="inline-block w-3 h-3 ltr:mr-1 rtl:ml-1" /> <span className="align-middle">Overview</span></Link>
            </li> */}
            <li>
              <Link data-modal-target="addUserModal" className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200" to="#!"
                onClick={() => {
                  const data = cell.row.original;
                  handleUpdateDataClick(data);
                }}>
                <FileEdit className="inline-block w-3 h-3 ltr:mr-1 rtl:ml-1" /> <span className="align-middle">Edit</span></Link>
            </li>
            {
              cell.row.original.status === 'active' &&
              <li>
                <Link className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200" to="#!" onClick={() => {
                  const orderData = cell.row.original;
                  onClickDelete(orderData);
                }}><Trash2 className="inline-block w-3 h-3 ltr:mr-1 rtl:ml-1" /> <span className="align-middle">Inactivate</span></Link>
              </li>
            }
            {
              cell.row.original.status === 'inactive' &&
              <li>
                <Link className="block px-4 py-1.5 text-base transition-all duration-200 ease-linear text-slate-600 hover:bg-slate-100 hover:text-slate-500 focus:bg-slate-100 focus:text-slate-500 dark:text-zink-100 dark:hover:bg-zink-500 dark:hover:text-zink-200 dark:focus:bg-zink-500 dark:focus:text-zink-200" to="#!" onClick={() => {
                  const orderData = cell.row.original;
                  onClickActive(orderData);
                }}><CheckCircle className="inline-block w-3 h-3 ltr:mr-1 rtl:ml-1" /> <span className="align-middle">Activate</span></Link>
              </li>
            }
          </Dropdown.Content>
        </Dropdown>
      ),
    }
  ], []
  );

  const options = [
    { value: 'Select Status', label: 'Select Status' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'rejected', label: 'Rejected' },
    { value: 'hidden', label: 'Hidden' },
  ];

  const handleChange = (selectedOption: any) => {
    if (selectedOption.value === 'Select Status' || selectedOption.value === 'Hidden') {
      setUser(userList);
    } else {
      const filteredUsers = userList.filter((data: any) => data.status === selectedOption.value);
      setUser(filteredUsers);
    }
  };

  return (
    <React.Fragment>
      <BreadCrumb title='List View' pageTitle='Users' />
      <DeleteModal show={deleteModal} onHide={deleteToggle} onDelete={handleDelete} />
      <ActiveModal show={activeModal} onHide={activeToggle} onActive={handleActive} />
      <ToastContainer closeButton={false} limit={1} />
      <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12">
        <div className="xl:col-span-12">
          <div className="card" id="usersTable">
            <div className="card-body">
              <div className="flex items-center">
                <h6 className="text-15 grow">Users List</h6>
                <div className="shrink-0">
                  <button type="button" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20" onClick={toggle}><Plus className="inline-block w-4 h-4" /> <span className="align-middle">Add User</span></button>
                </div>
              </div>
            </div>
            <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
              <form action="#!">
                <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                  <div className="relative xl:col-span-2">
                    <input type="text" className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Search for name, email, phone number etc..." autoComplete="off" onChange={(e) => filterSearchData(e)} />
                    <Search className="inline-block w-4 h-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                  </div>
                  <div className="xl:col-span-2">
                    <Select
                      className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      options={options}
                      isSearchable={false}
                      defaultValue={options[0]}
                      onChange={(event: any) => handleChange(event)}
                      id="choices-single-default"
                    />
                  </div>
                  {/* <div className="xl:col-span-3 xl:col-start-10">
                    <div className="flex gap-2 xl:justify-end">
                      <div>
                        <button type="button" className="bg-white border-dashed text-custom-500 btn border-custom-500 hover:text-custom-500 hover:bg-custom-50 hover:border-custom-600 focus:text-custom-600 focus:bg-custom-50 focus:border-custom-600 active:text-custom-600 active:bg-custom-50 active:border-custom-600 dark:bg-zink-700 dark:ring-custom-400/20 dark:hover:bg-custom-800/20 dark:focus:bg-custom-800/20 dark:active:bg-custom-800/20"><Download className="inline-block w-4 h-4" /> <span className="align-middle">Import</span></button>
                      </div>
                      <button className="flex items-center justify-center w-[37.5px] h-[37.5px] p-0 text-slate-500 btn bg-slate-100 hover:text-white hover:bg-slate-600 focus:text-white focus:bg-slate-600 focus:ring focus:ring-slate-100 active:text-white active:bg-slate-600 active:ring active:ring-slate-100 dark:bg-slate-500/20 dark:text-slate-400 dark:hover:bg-slate-500 dark:hover:text-white dark:focus:bg-slate-500 dark:focus:text-white dark:active:bg-slate-500 dark:active:text-white dark:ring-slate-400/20"><SlidersHorizontal className="w-4 h-4" /></button>
                    </div>
                  </div> */}
                </div>
              </form>
            </div>
            <div className="card-body">
              {user && user.length > 0 ?
                <TableContainer
                  isPagination={true}
                  columns={(columns || [])}
                  data={(user || [])}
                  customPageSize={10}
                  divclassName="-mx-5 -mb-5 overflow-x-auto"
                  tableclassName="w-full border-separate table-custom border-spacing-y-1 whitespace-nowrap"
                  theadclassName="text-left relative rounded-md bg-slate-100 dark:bg-zink-600 after:absolute ltr:after:border-l-2 rtl:after:border-r-2 ltr:after:left-0 rtl:after:right-0 after:top-0 after:bottom-0 after:border-transparent [&.active]:after:border-custom-500 [&.active]:bg-slate-100 dark:[&.active]:bg-zink-600"
                  thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold"
                  tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5"
                  PaginationClassName="flex flex-col items-center mt-8 md:flex-row"
                />
                :
                (<div className="noresult">
                  <div className="py-6 text-center">
                    <Search className="w-6 h-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
                    <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                    <p className="mb-0 text-slate-500 dark:text-zink-200">We've searched more than 199+ users We did not find any users for you search.</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>


      {/* User Modal  */}
      <Modal show={show} onHide={toggle} id="defaultModal" modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[70rem] bg-white shadow rounded-md dark:bg-zink-600">
        <Modal.Header className="flex items-center justify-between p-4 border-b dark:border-zink-300/20"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500">
          <Modal.Title className="text-16">{!!isEdit ? "Edit User" : "Add User"}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form action="#!" onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}>
            <div className="mb-3">
              <label htmlFor="imageInput" className="inline-block mb-2 text-base font-medium">Profile Picture</label>
              <DropZoneImage
                maxFiles={1}
                selectfiles={selectfiles}
                setSelectfiles={setSelectfiles}
                formikData={validation}
                fieldName='profilePicture'
                files={validation.values.profilePictureFile}
              />
              {validation.touched.customerAddress && validation.errors.image ? (
                <p className="text-red-400">{validation.errors.image}</p>
              ) : null}
            </div>
            <div className="mb-3 flex items-center gap-3">
              <label
                htmlFor={`isProfileDisplayInput`}
                className="flex flex-col gap-4 p-5 border rounded-md cursor-pointer md:flex-row border-slate-200 dark:border-zink-500 peer-checked:border-purple-500 dark:peer-checked:border-purple-700">
                <span className="grow flex items-center gap-3">
                  <input id={`isProfileDisplayInput`}
                    className="w-4 h-4 border appearance-none cursor-pointer bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-purple-500 checked:border-purple-500 dark:checked:bg-purple-500 dark:checked:border-purple-500 checked:disabled:bg-purple-400 checked:disabled:border-purple-400 peer"
                    type="checkbox"
                    name="isProfileDisplay"
                    checked={validation.values.isProfileDisplay}
                    onChange={validation.handleChange} />
                  <span className="block font-semibold text-15">Profile Display</span>
                </span>
              </label>
            </div>
            <div className="mb-3 flex items-center gap-3">
              <label
                htmlFor={`performServiceInput`}
                className="flex flex-col gap-4 p-5 border rounded-md cursor-pointer md:flex-row border-slate-200 dark:border-zink-500 peer-checked:border-purple-500 dark:peer-checked:border-purple-700">
                <span className="grow flex items-center gap-3">
                  <input id={`performServiceInput`}
                    className="w-4 h-4 border appearance-none cursor-pointer bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-purple-500 checked:border-purple-500 dark:checked:bg-purple-500 dark:checked:border-purple-500 checked:disabled:bg-purple-400 checked:disabled:border-purple-400 peer"
                    type="checkbox"
                    name="performService"
                    checked={validation.values.performService}
                    onChange={validation.handleChange} />
                  <span className="block font-semibold text-15">Perform Service</span>
                </span>
              </label>
            </div>
            <div className="mb-3">
              <label htmlFor="titleInput" className="inline-block mb-2 text-base font-medium">Title</label>
              <input type="text" id="titleInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Title"
                name="title"
                onChange={validation.handleChange}
                value={validation.values.title || ""}
              />
              {validation.touched.title && validation.errors.title ? (
                <p className="text-red-400">{validation.errors.title}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="usernameInput" className="inline-block mb-2 text-base font-medium">Username (Default will be email)</label>
              <input type="text" id="usernameInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Enter Username"
                name="username"
                onChange={validation.handleChange}
                value={validation.values.username || ""}
              />
              {validation.touched.username && validation.errors.username ? (
                <p className="text-red-400">{validation.errors.username}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="nameInput" className="inline-block mb-2 text-base font-medium">Name</label>
              <input type="text" id="nameInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Enter name"
                name="name"
                onChange={validation.handleChange}
                value={validation.values.name || ""}
              />
              {validation.touched.name && validation.errors.name ? (
                <p className="text-red-400">{validation.errors.name}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="roleInput" className="inline-block mb-2 text-base font-medium">Role</label>
              <Select
                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                options={roleSelect}
                isSearchable={false}
                name="role"
                id="roleInput"
                onChange={selectedOption => {
                  validation.setFieldValue(`role`, selectedOption?.value)
                }}
                value={roleSelect?.find(role => { return role.value === validation.values.role })}
              />
              {validation.touched.role && validation.errors.role ? (
                <p className="text-red-400">{validation.errors.role}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="emailInput" className="inline-block mb-2 text-base font-medium">Email</label>
              <input type="email" id="emailInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Enter email"
                name="email"
                onChange={validation.handleChange}
                value={validation.values.email || ""}
              />
              {validation.touched.email && validation.errors.email ? (
                <p className="text-red-400">{validation.errors.email}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="phoneNoInput" className="inline-block mb-2 text-base font-medium">Phone Number</label>
              <input type="text" id="phoneNoInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="+62811111111"
                name="phoneNo"
                onChange={validation.handleChange}
                value={validation.values.phoneNo || ""}
              />
              {validation.touched.phoneNo && validation.errors.phoneNo ? (
                <p className="text-red-400">{validation.errors.phoneNo}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="countryInput" className="inline-block mb-2 text-base font-medium">Country</label>
              <Select
                className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                options={countrySelect}
                isSearchable={false}
                name="country"
                id="countryInput"
                onChange={selectedOption => {
                  validation.setFieldValue(`country`, selectedOption?.value)
                }}
                value={countrySelect.find(country => { return country.value === validation.values.country })}
              />
              {validation.touched.country && validation.errors.country ? (
                <p className="text-red-400">{validation.errors.country}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="addressInput" className="inline-block mb-2 text-base font-medium">Address</label>
              <input type="text" id="addressInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Address"
                name="address"
                onChange={validation.handleChange}
                value={validation.values.address || ""}
              />
              {validation.touched.address && validation.errors.address ? (
                <p className="text-red-400">{validation.errors.address}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="descriptionInput" className="inline-block mb-2 text-base font-medium">Description</label>
              <textarea id="descriptionInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Description"
                name="description"
                onChange={validation.handleChange}
                value={validation.values.description || ""}
              />
              {validation.touched.description && validation.errors.description ? (
                <p className="text-red-400">{validation.errors.description}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="serviceInput" className="inline-block mb-2 text-base font-medium">Service</label>
              <input type="text" id="serviceInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Service"
                name="service"
                onChange={validation.handleChange}
                value={validation.values.service || ""}
              />
              {validation.touched.service && validation.errors.service ? (
                <p className="text-red-400">{validation.errors.service}</p>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="occupationInput" className="inline-block mb-2 text-base font-medium">Occupation</label>
              <input type="text" id="occupationInput" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Occupation"
                name="occupation"
                onChange={validation.handleChange}
                value={validation.values.occupation || ""}
              />
              {validation.touched.occupation && validation.errors.occupation ? (
                <p className="text-red-400">{validation.errors.occupation}</p>
              ) : null}
            </div>
            <OperatingHours
              formik={validation}
              types={[{ key: 'onsite', label: 'Onsite Schedule' }, { key: 'offsite', label: 'Offsite Schedule' }]}
              fieldPath="operation"
            />
            <div className="flex justify-end gap-2 mt-4">
              <button type="reset" data-modal-close="addDocuments" className="text-red-500 transition-all duration-200 ease-linear bg-white border-white btn hover:text-red-600 focus:text-red-600 active:text-red-600 dark:bg-zink-500 dark:border-zink-500" onClick={toggle}>Cancel</button>
              <button type="submit" className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                {!!isEdit ? "Update User" : "Add User"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default ListView;
